module.exports = "/_next/static/images/CustomerDataFoundationMobile@2x-b39d631ad1700138c7af0bedc169bd84.webp";